<template>
  <div class="text-h6">バックグラウンド</div>
  <div class="row q-mt-sm">
    <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
      <div>タイプ</div>
      <div class="text-caption">type</div>
    </div>
    <q-select
      outlined
      dense
      v-model="backgroundType"
      :options="['', 'linearGradient']"
      class="col"
    />
  </div>
  <template v-if="backgroundType">
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>勾配角度</div>
        <div class="text-caption">angle</div>
      </div>
      <q-input
        outlined
        dense
        v-model="value.angle"
        :rules="[
          (val) => degValidate(val) || 'invalid property',
        ]"
        placeholder="XXdeg"
        class="col"
      />
    </div>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>開始点色</div>
        <div class="text-caption">startColor</div>
      </div>
      <q-input
        outlined
        dense
        v-model="value.startColor"
        :rules="[
          (val) => colorValidate(val) || 'invalid property',
        ]"
        placeholder="#FFFFFF"
        class="col flex-input"
      >
        <template v-slot:append>
          <q-icon name="colorize" class="cursor-pointer">
            <q-popup-proxy cover transition-show="scale" transition-hide="scale">
              <q-color no-header no-footer v-model="value.startColor" />
            </q-popup-proxy>
          </q-icon>
        </template>
      </q-input>
    </div>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>中間色</div>
        <div class="text-caption">centerColor</div>
      </div>
      <q-input
        outlined
        dense
        v-model="value.centerColor"
        :rules="[
          (val) => colorValidate(val) || 'invalid property',
        ]"
        placeholder="#FFFFFF"
        class="col flex-input"
      >
        <template v-slot:append>
          <q-icon name="colorize" class="cursor-pointer">
            <q-popup-proxy cover transition-show="scale" transition-hide="scale">
              <q-color no-header no-footer v-model="value.centerColor" />
            </q-popup-proxy>
          </q-icon>
        </template>
      </q-input>
    </div>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>終了点色</div>
        <div class="text-caption">endColor</div>
      </div>
      <q-input
        outlined
        dense
        v-model="value.endColor"
        :rules="[
          (val) => colorValidate(val) || 'invalid property',
        ]"
        placeholder="#FFFFFF"
        class="col flex-input"
      >
        <template v-slot:append>
          <q-icon name="colorize" class="cursor-pointer">
            <q-popup-proxy cover transition-show="scale" transition-hide="scale">
              <q-color no-header no-footer v-model="value.endColor" />
            </q-popup-proxy>
          </q-icon>
        </template>
      </q-input>
    </div>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>中間色位置</div>
        <div class="text-caption">centerPosition</div>
      </div>
      <q-input
        outlined
        dense
        v-model="value.centerPosition"
        :rules="[
          (val) => percentageValidate(val) || 'invalid property',
        ]"
        placeholder="Num. %"
        class="col"
      />
    </div>
  </template>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import { IFlexMessageBoxBackground } from '@/utils/types'
import cloneDeep from 'lodash/cloneDeep'

@Options({
  components: {},
  directives: { maska },
  emits: ['update:modelValue'],
})
export default class Background extends Vue {
  @Prop()
  modelValue!: IFlexMessageBoxBackground

  linearGradient: IFlexMessageBoxBackground = {
    type: 'linearGradient',
    angle: '0deg',
    startColor: '#000000',
    endColor: '#ffffff',
  }

  get value() {
    return this.modelValue
  }

  set value(value: IFlexMessageBoxBackground | undefined) {
    this.$emit('update:modelValue', value)
  }

  get backgroundType() {
    return this.modelValue?.type ?? ''
  }

  set backgroundType(value: string) {
    if (value === 'linearGradient') {
      this.value = cloneDeep(this.linearGradient)
    } else {
      this.value = undefined
    }
  }

  colorValidate(val) {
    if (!val) return true
    return /^#[0-9A-Fa-f]{6}([0-9A-Fa-f]{2})?$/.test(val)
  }

  percentageValidate(val) {
    if (!val) return true

    const match = /^(\d{1,3}(?:\.\d+)?)%$/.exec(val)
    if (!match) return false

    const num = Number(match[1])
    return !(num < 0 || num > 100)
  }

  degValidate(val) {
    if (!val) return true

    const match = /^(\d{1,3}(?:\.\d+)?)deg$/.exec(val)
    if (!match) return false

    const num = Number(match[1])
    return !(num < 0 || num > 360)
  }
}
</script>

<style scoped lang="scss">

</style>
